import { render, staticRenderFns } from "./AccountShopOrder.vue?vue&type=template&id=ecf5308a&"
import script from "./AccountShopOrder.vue?vue&type=script&lang=ts&"
export * from "./AccountShopOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports